import React, { createContext, useEffect, useState } from 'react';

const UserContext = createContext({
    user: { id: 1, name: 'test' },
    userRoles: [],
    updateUser: () => {},
    userIP: null,
    secureIpAddresses: null,
});

const UserProvider = function(props) {
    const [user, setUser] = useState({});
    const [userRoles, setUserRoles] = useState([]);
    const [userIP, setUserIP] = useState(null);
    const [secureIpAddresses, setSecureIpAddresses] = useState(null);

    useEffect(() => {
        async function fetchClientIP() {
            try {
                // zelfde origin: /auth/api/client-ip → Laravel api.php
                const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/$/, ''); // strip trailing /
                const response = await fetch(`${baseUrl}/auth/client-ip`, {
                    credentials: 'same-origin', // of 'include', beide ok in jouw setup
                });
                if (!response.ok) throw new Error('IP request failed');
                const data = await response.json();
                console.log('Client IP via backend:', data.ip);
                setUserIP(data.ip);
            } catch (error) {
                console.warn('Kon client-IP niet ophalen:', error);
                setUserIP(null);
            }
        }

        fetchClientIP();
    }, []);

    function updateUser(user) {
        setUser(user);

        let userRoles = [];
        user.userRoles.forEach(role => {
            userRoles.push(role.roleCode);
        });
        setUserRoles(userRoles);
    }

    function resetCurrentUserToDefault() {
        setUser({});
        setUserRoles([]);
    }

    function updateSecureIpAddress(payload) {
        setSecureIpAddresses(Array.isArray(payload) ? payload : []);
    }

    return (
        <UserContext.Provider
            value={{
                user: user,
                userRoles: userRoles,
                updateUser: updateUser,
                resetCurrentUserToDefault,
                updateSecureIpAddress,
                userIP,
                secureIpAddresses,
            }}
        >
            {props.children}
        </UserContext.Provider>
    );
};

const UserConsumer = UserContext.Consumer;

export { UserProvider, UserConsumer, UserContext };
